import { api } from './api';

/* Mirrors Eduvora.Application.Staff.
   ⚠ Every *Paise field is null unless the caller is in `tenant-admin`. Payroll is admin-only in
   this product and this screen does not widen that — see StaffOverviewEndpoints. */

export interface StaffRow {
  employeeId: string;
  code: string;
  fullName: string;
  designation: string | null;
  department: string | null;
  employmentType: string;
  joiningDate: string;
  exitDate: string | null;
  tenureYears: number;

  todayStatus: string;
  /** ⚠ null means nothing was marked in that window — NOT 0%. Render "—". */
  thisMonthPct: number | null;
  thisYearPct: number | null;
  lastYearPct: number | null;
  presentDaysThisYear: number;
  absentDaysThisYear: number;
  leaveDaysThisYear: number;
  leaveBalanceDays: number;
  onLeaveToday: boolean;

  monthlyGrossPaise: number | null;
  lastPayslipNetPaise: number | null;
  paidThisFyPaise: number | null;
  paidLastFyPaise: number | null;

  classesOwned: string[];
}

export interface StaffTotals {
  headcount: number;
  teaching: number;
  support: number;
  joinedThisYear: number;
  leftThisYear: number;
  averageTenureYears: number;

  presentToday: number;
  absentToday: number;
  onLeaveToday: number;
  unmarkedToday: number;
  attendancePctThisMonth: number | null;

  monthlyGrossPaise: number | null;
  monthlyNetPaise: number | null;
  employerContributionsPaise: number | null;
  paidThisFyPaise: number | null;
  paidLastFyPaise: number | null;
}

export interface PayrollMonth { month: string; payslips: number; grossPaise: number; netPaise: number }

export interface StaffOverview {
  financialYear: string;
  previousFinancialYear: string;
  asOf: string;
  includesPay: boolean;
  totals: StaffTotals;
  months: PayrollMonth[];
  staff: StaffRow[];
  note: string | null;
}

export const staffOverviewApi = {
  load: (withPay: boolean) =>
    api.get<StaffOverview>(withPay ? '/api/staff/overview/pay' : '/api/staff/overview'),
};

/** ₹4.81 L / ₹1.2 Cr — Indian grouping, because ₹4,810,000 is not how anyone here reads a payroll. */
export function lakh(paise: number | null): string {
  if (paise === null) return '—';
  const r = paise / 100;
  if (Math.abs(r) >= 1e7) return `₹${(r / 1e7).toFixed(2)} Cr`;
  if (Math.abs(r) >= 1e5) return `₹${(r / 1e5).toFixed(2)} L`;
  return `₹${Math.round(r).toLocaleString('en-IN')}`;
}
